import { render, staticRenderFns } from "./ShowContactMessages.vue?vue&type=template&id=aac30622&"
import script from "./ShowContactMessages.vue?vue&type=script&lang=js&"
export * from "./ShowContactMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports